import { drawing } from '@progress/kendo-drawing';
import { isFunction } from './../common';

var dotsPattern = drawing.dotsPattern;
var verticalStripesPattern = drawing.verticalStripesPattern;
var crosshatchPattern = drawing.crosshatchPattern;
var diagonalStripesPattern = drawing.diagonalStripesPattern;
var gridPattern = drawing.gridPattern;

var patternMap = {
    dots: dotsPattern,
    verticalStripes: verticalStripesPattern,
    crosshatch: crosshatchPattern,
    diagonalStripes: diagonalStripesPattern,
    grid: gridPattern
};

export function evaluatePattern(options, point) {
    return isFunction(options) ? options(point) : options;
}

export function createPatternFill(options, fill, point) {
    var patternOptions = evaluatePattern(options, point);
    var pattern = patternOptions && patternMap[patternOptions.type];

    return pattern ? pattern(Object.assign({}, fill, patternOptions)) : fill;
}
